import * as React from 'react';
import { styled } from '@mui/system';
import { fm } from 'Components/FormatMessage';
import colors from '../../../../../config/theme/colors';
import ClearIcon from '@mui/icons-material/Clear';

const InlineDiv = styled('div')({
  display: 'inline-flex',
});

export const StyledTitle = styled('div')({
  fontSize: '1.4rem',
  margin: '1rem 0 1rem 0',
});

export const ClearIconStyled = styled(ClearIcon)({
  display: 'block',
  width: '3rem',
  color: `${colors.secondaryText}`,
  cursor: 'pointer',
  '&:hover': {
    color: 'red',
  },
});

const StyledCollapsedValue = styled('div')({
  color: colors.black,
  fontWeight: 600,
});

export const CollapsedContent = ({
  name,
  value,
  locPath,
}: {
  name: string;
  value: TFieldValue;
  locPath?: string;
}): React.JSX.Element => {
  switch (name) {
    case 'includeDeceased': {
      let returnValue;
      if (typeof value === 'string') {
        returnValue =
          value === 'noCropping' ? fm('extendedSearch.opts.noCropping') : locPath ? fm(`${locPath}.${value}`) : value;
      } else {
        returnValue = undefined;
      }
      return <StyledCollapsedValue key={name}>{returnValue ?? '-'}</StyledCollapsedValue>;
    }
    default: {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <InlineDiv style={{ paddingRight: '1rem' }}>
            <div style={{ backgroundColor: colors.info.light, width: '1rem', height: '1rem', borderRadius: '100%' }} />
          </InlineDiv>
          <InlineDiv>
            <span style={{ color: colors.black, fontWeight: 600, fontStyle: 'italic' }}>
              {fm('extendedSearch.searchCriteriaActive')}
            </span>
          </InlineDiv>
        </div>
      );
    }
  }
};
